import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Link, useParams } from "react-router-dom";
import Popup from 'reactjs-popup';
import { useAuth } from "../../hooks/useAuth";
import { useConfig, useConfigs, useConfigsApi } from "../../hooks/useConfig";
import { usePalette } from "../../hooks/usePalette";
import { useProjectId } from "../../hooks/useProjectId";
import { TextFrame, VerifyFrame } from "../modal-dialog/VerifyFrame";
import { LeftMenu } from "../nav/LeftMenu";
import { Main } from "../nav/Main";
import { EditConfig } from "./EditConfig";
import { NewConfig } from "./NewConfig";


export const Configs = (props) => {

    const { project_id, subscription_id } = useProjectId();
    const auth = useAuth();
    const dispatch = useDispatch();

    const routerParams = useParams();
    const selectedItemId = routerParams.id;
    const history = useHistory();

    const api = useConfigsApi();
    
    const [items, itemsLoading, itemsError] = useConfigs();
    const [selectedItem] = useConfig(selectedItemId);

    const closeLeftMenu = () => {
        //dispatch({ type: "LEFT_MENU_OPEN_SET", value: false });
    }

    return <>
        
        <LeftMenu>
            <div className='title'>
                Configs
            </div>
            <div className='top-section'>

            </div>
            <div className='scroller'>
                <div className='summary'>
                    <p>
                        Description here for configs.
                    </p>
                </div>
                {
                    itemsError ? <div className='list-content error'>Error loading configs</div> :
                    itemsLoading ? <div className='list-content'>Loading...</div> :
                    !items ? null :
                    [...items]
                        .sort((a, b) => a.label?.localeCompare(b.label))
                        .map(item => <div key={item.id} className={`menu-item ${item.id === selectedItemId ? 'sel' : ''}`}>
                            <span className='grip'>
                                <i className='fad fa-sliders-h' />
                            </span>
                            <Link
                                className='label'
                                to={`/subscription/${subscription_id}/project/${project_id}/config/${item.id}`}
                                onClick={() => closeLeftMenu()}
                            >
                                {item.label}
                            </Link>
                            <Popup
                                nested
                                contentStyle={{ padding: '0px' }}
                                trigger={<span className='menu' ><i className='far fa-ellipsis-h' /></span>}
                                position="right top">
                                {closeMenu => <ul className='popup-menu'>
                                        <Popup modal trigger={
                                            <li>Rename</li>
                                        }>
                                            {closeModal => <TextFrame
                                                title={"Rename config"}
                                                label={item.label}
                                                initialTextValue={item.label}
                                                close={closeModal} confirmed={async (text) => {
                                                    const newItem = {
                                                        ...selectedItem,
                                                        label: text
                                                    };
                                                    await api.updateItem(item.id, newItem);
                                                }}
                                            />}
                                        </Popup>
                                    
                                        <Popup modal trigger={
                                            <li>Delete config</li>
                                        }>
                                            {closeModal => <VerifyFrame
                                                title={"Delete config"}
                                                label={item.label}
                                            close={closeModal}
                                            confirmed={async () => {
                                                await api.deleteItem(item.id);
                                                // navigate away?
                                            }}
                                        />}
                                        </Popup>
                                </ul>}
                            </Popup>
                        </div>)
                }
                <div className='menu-item-stub center'>
                    <Popup
                        modal
                        trigger={
                            <div className="btn action" >
                                <i className='glyph fal fa-plus' /> New config
                            </div>
                        }>
                        {close => <NewConfig close={close} onNew={(itemInfo) => {
                            history.push(`/subscription/${subscription_id}/project/${project_id}/config/${itemInfo.newId}`);
                        }} />}
                    </Popup>
                </div>
                
            </div>
        </LeftMenu>

        <Main>
            {selectedItem ? <EditConfig key={selectedItem.id} id={selectedItem.id}/> : null}
        </Main>
        
    </>;


    
}

